import { GetAllList } from "@/services/application.service";
import type { ApplicationData } from "@/types/Application/application";
import { message } from "antd";
import { useEffect, useRef, useState } from "react";

export function useAllApplication() {
  const [loading, setLoading] = useState(true);
  const [applicationAllList, setApplicationAllList] =
    useState<ApplicationData | null>(null);
  const requestIdRef = useRef(0);

  const fetchAllList = async (
    search = "",
    pageNumber = 1,
    pageSize = 25,
    categoryKey = "",
    dateFrom = "",
  ) => {
    const requestId = ++requestIdRef.current;

    try {
      setLoading(true);

      const response = await GetAllList({
        pageNumber,
        pageSize,
        search,
        dateFrom,
        categoryKey,
      });

      if (requestId !== requestIdRef.current) {
        return;
      }

      setApplicationAllList(response.data);
    } catch (error) {
      if (requestId !== requestIdRef.current) {
        return;
      }

      message.error(
        error instanceof Error
          ? error.message
          : "Gagal mendapatkan senarai permohonan",
      );
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchAllList();
  }, []);

  return {
    fetchAllList,
    loading,
    applicationAllList,
  };
}